import React from 'react';

import { getBrandingColorPalette } from '../../base/styles';

export type StyleProps = {
    [key: K]: React.CSSProperties,
};

export const styleDeeplinking = (interfaceConfig = {}): StyleProps => {
    return {
        pageBackground: {
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.background,
            height: 'inherit',
            display: 'inherit',
            flexDirection: 'inherit'
        },
        deeplinkButtons: {
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.secondary,
            border: `1px solid ${getBrandingColorPalette(interfaceConfig)?.secondary}`
        },
        container: {
            maxWidth: '1120px!important',
            marginTop: '5%',
            margin: 'auto'
        },
        invalidMeeting: {
            width: '80%',
            maxWidth: '800px',
            borderRadius: '10px',
            margin: 'auto',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.primary,
            color: 'white',
            padding: '20px',
            textAlign: 'center'
        },
        floatRight: { float: 'right' },
        joinMeeting: {
            marginTop: '10px',
            marginBottom: '10px',
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : 'white',
            fontSize: '1.5rem',
            fontWeight: 500,
            lineHeight: '1.2'
        },
        launchMeeting: {
            width: '80%',
            maxWidth: '800px',
            borderRadius: '10px',
            marginTop: '45px',
            margin: 'auto',
            color: '#fff',
            padding: '20px',
            textAlign: 'center'
        },
        marginTop10: {
            marginTop: '10px',
            fontSize: '15px'
        },
        marginTop20: { marginTop: '20px',
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : 'white' },
        width100: {
            width: '100%',
            backgroundColor: getBrandingColorPalette(interfaceConfig)?.primary
        },
        marginTop101: {
            marginTop: '10px',
            fontSize: '15px',
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : 'white'
        },
        continueBrowser: {
            marginTop: '10px',
            fontSize: '18px',
            color: '#fff'
        },
        continueBrowseranchor: {
            color: interfaceConfig.applyMeetingSettings ? getBrandingColorPalette(interfaceConfig)?.accent1 : '#cfebff',
            gap: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }

    };
};
